<template>
  <div>
    <div class=" mainLoader" v-if="loading"></div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('cp_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('cp_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/companyprofile.png" class="pman"/>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-side-bar :selectedItem="selectedItem"></app-side-bar>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-12 specialheader">
                <div class="page_title" style="float: left;">
                  <span class="page_title_comment mplus2p-m spacing1-2 noiseblack" style="float: left;">{{$t('job_title')}}</span>
                </div>
                <div v-if="role != 'engineer'" style="float: right;">
                  <router-link :to="{ name: 'companyRecuritAdd', params: {cid: companyId, uid: userId} }">
                    <span class="btn bluebtn mplus2p-r rlistbtn" style="float: right;">
                        <span style="font-size: 1.4rem;">+</span>&nbsp;&nbsp;
                        <span>{{$t('job_button')}}</span>
                    </span>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="row pview" v-if="recruitList != ''">
              <div class="col-md-12 ceboxes" v-for="(recruit,index) of recruitList" :key="index">
                <div class="row">
                  <div class="col-md-11" style="text-align: left;">
                    <router-link :to="{ name: 'companyRecuritDetail', params: {rid: recruit.id} }" target="_blank">
                      <p class="ctitle mplus2p-m spacing1-2 noiseblack">{{recruit.subject}}</p>
                    </router-link>
                    <hr class="cline"/>
                    <p class="ccontents mplus2p-m spacing1-2 noiseblack" >{{recruit.content}}
                    </p>
                  </div>
                  <div class="col-md-1">
                    <button class="btn clickcbtn bluebtn " @click="editRecruit(recruit.id)" style="margin-right: 10px;">
                      <i class="fa fa-pencil margin-r-5"></i>
                    </button>
                  </div>  
                </div>
              </div>
            </div>
            <div class="row pview" v-if="recruitList.length == 0">
              <div class="col-md-12 ceboxes">
                <div class="alert alert-danger">
                  <strong>{{$t('err_recruitAvailable')}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavSidebar from "./company_sidebar";
  import axios from "axios";
  export default {
    data() {
      return {
        selectedItem: 21,
        model: {},
        window_width: "",
        recruitList: [],
        company: '',
        companyId: "",
        userId: '',
        loading: false,
        image: null,
        role: "",
        current_page: "",
        record: "",
        show: false,
        pageId: ""
      };
    },
    mounted() {
      this.window_width = $(window).width() + 17; //d
    },
    created() {
      this.role = localStorage.getItem("role");
      var data = JSON.parse(localStorage.getItem("user"));
      this.userId = data.user_token;
      this.companyId = data.company.company_token;
      if (this.userId != this.$route.params.uid || this.companyId != this.$route.params.cid) {
        this.$router.push("/global/PageNotFound");
      }
      if (process.env.VUE_APP_RECRUIT_HIDE_FLAG === 'true') {
        this.$router.push("/global/PageNotFound");
      }
      this.getRecruitList(data.company.id);
    },
    computed: {
      onResize(event) {
        this.window_width = $(window).width() + 17;
        this.showorhide();
      }
    },
    components: {
      appSideBar: NavSidebar
    },
    methods: {
      getRecruitList(id) {
        this.loading = true;
        axios
          .get("company/" + id)
          .then(res => {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
              this.loading = false;
            }
            if (res.data.result) {
              try {
                this.recruitList = res.data.recruit_list;
                this.company = res.data.company;
                this.recruitList.reverse()
                this.loading = false;
                this.$forceUpdate()
              } catch (error) {
              }

            }
          })
          .catch(error => {
            this.loading = false;
          });
      },
      editRecruit(id){
        var data = JSON.parse(localStorage.getItem("user"));
        var uId = data.user_token;
        var cId = data.company.company_token;
        this.$router.push({ name: "companyRecuritEdit",params: {cid: cId, uid: uId, rid:id}});
      }


    }
  };
</script>

<style scoped>
  .pman {
  width: auto;
   margin-top: 70px;
  }

  .slide_options {
    background-color: #f8fafa;
    border-radius: 30px;
    margin: 10px 0px;
    margin-top: 44px;
    padding: 5px 0px;
  }

  .slide_item {
    text-align: center;
    padding: 18px;
    cursor: pointer;
  }

  .spressed {
    text-align: center;
    padding: 18px;
    border-radius: 30px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
  }

  .slide_txt {
    font-size: 1rem;
    font-weight: bold;
    color: #b4bec8;
  }

  .spressed .slide_txt {
    font-size: 1rem;
    font-weight: bold;
    color: #3d7dd8;
  }


  .company {
    width: 80%;
  }

  .pgraytxt {
    opacity: 0.64;
    font-size: 1rem;
    font-weight: 500;
  }

  .cs_summary {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    margin-top: 21px;
  }

  .pvlabel {
    margin-left: 20px;
  }

  .pv_btnpanel {
    padding: 0px 10%;
  }

  .updatebtn {
    width: 100%;
    height: 56px;
  }

  .pv_showchart {
    background-color: #f8f8fa;
    margin-top: 16px;
  }

  .eview {
    padding: 30px 15px;
  }

  .chartboxes {
    display: block;
    margin: auto;
    margin-bottom: 30px;
    max-width: 200px;
    height: 100px;
  }

  .statustitle {
    font-size: 1.25rem;
    font-weight: bold;
    margin-top: 34px;
    margin-bottom: 0.1rem;
  }

  .statusnum {
    position: absolute;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .caltxt {
    margin-top: 45px;
  }

  .calpanel {
    text-align: right;
  }

  .camera {
    box-shadow: 0 2px 4px 0 rgba(40, 60, 80, 0.12);
    background-color: #ffffff;
    border: solid 1px #c8d2dc;
    border-radius: 100px;
    padding: 8px 9px;

    position: absolute;
    top: 105px;
    right: 30px;
    cursor: pointer;
  }

  .camera:hover {
    background-color: #3d7dd8;
  }

  .camera:hover .fa-camera {
    color: white;
  }

  .camera .fa-camera {
    font-size: 20px;
    color: #3d7dd8;
  }

  .peditlabel {
    font-size: 1rem;
    font-weight: 500;
    margin-left: 20px;
    margin-top: 20px;
  }

  .peditinput {
    width: 100%;
    height: 44px;
    padding: 0px 16px;
    margin-left: 20px;
  }

  .pedittextarea {
    width: 100%;
    height: 188px;
    padding: 16px;
    margin-left: 20px;
  }

  .peselectboxs {
    float: left;
    margin-left: 20px;
  }

  .selectdiv select {
    height: 50px !important;
  }

  .peradioboxs {
    text-align: center;
    min-width: 128px;
    height: 50px;
    float: left;
    background-color: #ffffff;
    border: 1px solid #b4bec8;
    color: #b4bec8;
    margin-left: 20px;
    margin-top: 5px;
    padding-top: 10px;
    border-radius: 4px;
    cursor: pointer;
  }

  .manradio:hover,
  .mchosen {
    border: 1px solid #3d7dd8;
    color: #3d7dd8;
  }

  .womenradio:hover,
  .wchosen {
    border: 1px solid #f878c8;
    color: #f878c8;
  }


  .peradiotxt {
    font-size: 0.875rem;
    font-weight: bold;
  }

  .linput {
    width: 423px;
  }

  .help-block {
    margin-left: 20px;
    margin-top: 10px;
  }

  .form-group {
    margin-bottom: 0px;
  }

  .upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
  }

  .upload-btn-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    top: 105px;
    right: 30px;
    opacity: 0;
  }

  .pheaderpanel {
    margin: 0px 20px;
    margin-top: 30px;
  }

  .pgraytxt {
    opacity: 0.64;
    font-size: 1rem;
    font-weight: 500;
  }

  .businesspanel {
    margin-top: 50px;
  }

  .futhergraytxt {
    font-size: 1rem;
    font-weight: 500;
    opacity: 0.64;
  }

  .pfpanel {
    height: 50px;
  }

  .blog1 {
    width: 100%;
  }

  .ceboxes {
    margin: 16px;
    margin-top: 26px;
    margin-bottom: 0px;
    text-align: center;
  }

  .c_images {
    margin-top: 10px;
    height: 120px;
    width: 100%;
    object-fit: contain;
  }

  .skillsets {
    text-align: left;
    padding: 9px 10px;
  }

  .ctitle {
     font-size: 1.125rem;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 10px;
    -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
    overflow: hidden;
     display: -webkit-box;
    text-overflow: ellipsis;
    word-wrap: break-word;
    text-align: justify;
  }
/* .ctitle{
  font-size: 1.125rem;
  font-weight: 500;
  text-align: justify;
  margin-bottom: 20px;
  margin-top: 10px;
} */
  .ccontents {
    font-size: 0.825rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  }

  .cline {
    border: solid 0.5px #e6e8ea;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .cstitle {
    font-size: 0.8125rem;
    font-weight: 500;
    margin-bottom: 15px;
  }

  .specialheader {
    height: 60px;
  }

  .rlistbtn {
    float: right;
    margin-right: -30px;
    margin-top: 10px;
    height: 48px;
    font-size: 0.875rem;
    font-weight: bold;
    padding: 6px 30px;
  }

  @media screen and (max-width: 1200px) {
    .camera {
      top: 80px;
      right: 20px;
    }

    .upload-btn-wrapper input[type="file"] {
      top: 80px;
      right: 20px;
    }

    .businesspanel {
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 992px) {
    .camera {
      top: 50px;
      right: 20px;
    }

    .upload-btn-wrapper input[type="file"] {
      top: 50px;
      right: 20px;
    }

    .linput {
      width: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    .pman {
      margin-top: 0px;
    }

    .company {
      width: 50%;
    }

    .page_title {
      margin-top: 40px;
    }

    .pvlabel {
      margin-left: 0px;
    }

    .calpanel {
      text-align: center;
    }

    .camera {
      top: 80%;
      right: 20%;
    }

    .peditlabel {
      margin-left: 0px;
    }

    .peditinput {
      margin-left: 0px;
    }

    .pedittextarea {
      margin-left: 0px;
    }

    .peselectboxs {
      width: 100%;
      margin-left: 0px;
    }

    .peradioboxs {
      width: 100%;
      margin-left: 0px;
    }

    .help-block {
      margin-left: 0px;
      margin-top: 10px;
    }

    .upload-btn-wrapper input[type="file"] {
      top: 80%;
      right: 20%;
    }

    .pheaderpanel {
      margin: 0px;
      margin-top: 30px;
    }

    .ceboxes .col-md-3 {
      margin-bottom: 30px;
    }

    .c_images {
      width: 144px;
    }

    .skillsets {
      padding: 0;
      margin-top: 20px;
    }

    .rlistbtn {
      margin-right: 0px;
      margin-top: 35px;
    }

    .specialheader {
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 575.98px) {
    .pman {
      width: 100%;
    }
  }
</style>
